/**
 * Converts any date-like value to a JavaScript Date object.
 * Accepts Date, ISO/string, epoch ms, leftover `{ seconds }` maps, and objects with toDate().
 */
export const toJSDate = (value) => {
  if (!value && value !== 0) return null;

  try {
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

    if (typeof value?.toDate === 'function') {
      const date = value.toDate();
      return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
    }

    if (typeof value === 'object' && 'seconds' in value) {
      const date = new Date(Number(value.seconds) * 1000);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    if (typeof value === 'number') {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    if (typeof value === 'string') {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    return null;
  } catch (error) {
    console.error('Error converting to Date:', error);
    return null;
  }
};

/**
 * Formats a date-like value to a string using the specified format
 */
export const formatDate = (value, formatStr, formatFn) => {
  const date = toJSDate(value);
  if (!date) return '';

  try {
    return formatFn(date, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
